import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import { useDropzone } from 'react-dropzone';

import { connect } from 'react-redux';
import { createShadow, importShadow } from 'components/shadow_grid/shadows/store/shadows/actions';

import Button from 'shared/button';
import Errors from 'components/form/errors';
import LoadingSpinner from 'components/loading_spinner';
import Modal from 'components/modal';
import ShadowCreationOrImportModalBody from './create_or_import';
import ShadowCreationModalBody from './create';

export function ShadowCreationModal({
  canImportShadows,
  createShadow,
  creatingShadow,
  grids,
  importShadow,
  show,
  onClose
}) {
  const [grid, setGrid] = useState();
  const [mode, setMode] = useState('create');
  const [importing, setImporting] = useState();
  const [errors, setErrors] = useState([]);

  const onSubmit = () => {
    if (mode === 'create') {
      setErrors([]);
      createShadow(grid);
    }
  };

  const submitDisabled = importing || creatingShadow || (mode === 'create' && !grid);
  let submitButton = <Button.Primary disabled={submitDisabled} onClick={onSubmit}>
    Create
  </Button.Primary>;

  const onDrop = useCallback(async (files) => {
    if (files.length === 0) {
      return;
    }

    setImporting(true);
    setErrors([]);

    try {
      await importShadow(files[0]);
      setImporting(false);
      onClose();
    } catch (errors) {
      setErrors(errors);
      setImporting(false);
    }
  }, []);

  const { getRootProps, getInputProps } = useDropzone({ noDrag: true, onDrop });
  if (mode === 'import') {
    submitButton = <div {...getRootProps()}>
      <input {...getInputProps()} />
      {submitButton}
    </div>;
  }

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        Create Grid
      </Modal.Header>

      <Modal.Body className="d-flex flex-column gap-3">
        {canImportShadows && grids.some(grid => grid.excelImportTarget) ? (
          <ShadowCreationOrImportModalBody
            grid={grid}
            grids={grids}
            mode={mode}
            onGridChange={setGrid}
            onModeChange={setMode}
          />
        ) : <ShadowCreationModalBody grid={grid} grids={grids} onGridChange={setGrid} />}

        {importing && <LoadingSpinner />}
        <Errors description={false} errors={errors} />
      </Modal.Body>

      <Modal.Footer>
        <Button.Cancel onClick={onClose} />
        {submitButton}
      </Modal.Footer>
    </Modal>
  );
}

ShadowCreationModal.propTypes = {
  canImportShadows: PropTypes.bool,
  createShadow: PropTypes.func.isRequired,
  creatingShadow: PropTypes.bool,
  grids: PropTypes.array.isRequired,
  importShadow: PropTypes.func.isRequired,
  show: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  canImportShadows: state.features.shadowGridCoreModels,
  creatingShadow: state.shadows.creatingShadow,
  grids: state.grids,
});

const mapDispatchToProps = {
  createShadow,
  importShadow,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShadowCreationModal);
